var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function writeToLocalStorage(key, value) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            try {
                if (typeof value === 'undefined') {
                    localStorage.removeItem(key);
                }
                else {
                    const serializedVal = JSON.stringify(value);
                    localStorage.setItem(key, serializedVal);
                }
                resolve();
            }
            catch (e) {
                if (__DEV__) {
                    console.error('Error writing to local storage', e);
                }
                // capture error
                reject(e);
            }
        });
    });
}
export function readFromLocalStorage(key) {
    return new Promise((resolve, reject) => {
        try {
            if (typeof window === 'undefined')
                return undefined;
            const serializedVal = localStorage.getItem(key);
            if (serializedVal == null) {
                return resolve(undefined);
            }
            resolve(JSON.parse(serializedVal));
        }
        catch (e) {
            if (__DEV__) {
                console.error('Error reading from local storage', e);
            }
            // capture error
            reject(e);
        }
    });
}
